import { TriggerType } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface AtLeastOneTriggerRequiredRuleDto {
  selectedTriggers?: TriggerType[];
}

export const AtLeastOneTriggerRequiredRuleKey = 'atLeastOneTriggerRequired';

/**
 * We require at least one trigger point to be set. Triggers are what determines when a message
 * should be shown on-site.
 *
 * @param triggerSettings
 * @returns 'fail', with an error message, if no triggers are chosen. 'pass' if any are chosen.
 */

export const AtLeastOneTriggerRequiredRule = (dto: AtLeastOneTriggerRequiredRuleDto): DomainRule => {
  if (dto.selectedTriggers?.length < 1) {
    return {
      result: 'fail',
      ruleKey: AtLeastOneTriggerRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
